'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const classNames = require('classnames');
const get = require('lodash.get');
const styles = require('./ShippingDetailsModal.scss');
const DetailsQuotes = require('./ShippingDetailsModal/DetailsQuotes');
const ModalCloseButton = require('dibs-elements/dist/ModalCloseButton').default;
const BarHeader = require('dibs-elements/dist/BarHeader').default;
const { FooterQuoteBlurb, FooterLegalBlurb } = require('./ShippingDetailsModal/DetailsFooter');
const copy = require('./ShippingDetailsModal.json');
const { OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION } = require('../../constants/shippingConstants');

function ShippingDetailsModal(props) {
    const { quotes = [], currency, closeShippingModal, user = {},
        source, openQuoteRequestModal, userId, itemId, viewer, item } = props;
    return (
        <div data-tn="shipping-details-modal" className={classNames('containerFluid', styles.wrapper)}>
            <BarHeader title={copy.title} />
            <ModalCloseButton onClick={closeShippingModal} />
            <div>
                <DetailsQuotes
                    quotes={quotes.shipmentQuotes}
                    currency={currency}
                    userId={userId}
                    itemId={itemId}
                    viewer={viewer}
                    item={item}
                />
                <FooterQuoteBlurb
                    openQuoteRequestModal={openQuoteRequestModal}
                    canRequestShippingQuote={get(user, 'canRequestShippingQuote', false)}
                    isVerifiedTrade={get(user, 'canSeeTradeReturns', false)}
                    quotes={quotes}
                    source={source}
                />
                <FooterLegalBlurb />
            </div>
        </div>
    );
}

ShippingDetailsModal.propTypes = {
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    closeShippingModal: PropTypes.func,
    currency: PropTypes.string.isRequired,
    user: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    openQuoteRequestModal: PropTypes.func,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(ShippingDetailsModal, {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                canSeeTradeReturns: hasPermission(name: "B_TRADE_RETURN_POLICY")
                canRequestShippingQuote: hasPermission(name: "B_REQUEST_SHIPPING_QUOTE")
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                ${DetailsQuotes.getFragment('item')}
            }
        `,
        viewer: ({itemId, userId }) => Relay.QL`
            fragment on Viewer {
                ${DetailsQuotes.getFragment('viewer', {itemId, userId})}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal.jsx